import { getCoreDataSecurityAccessExplainerByIdSlice } from './get';

export const { requestGetCoreDataSecurityAccessExplainerById, resetGetCoreDataSecurityAccessExplainerById } =
	getCoreDataSecurityAccessExplainerByIdSlice.asyncActionCreators;


